import React from 'react';

import { SignIn } from '@/modules/user/components';

const LoginPage = () => <SignIn />;

export default LoginPage;
